import './OkulSubelerDetailPage.scss'

import { Button, Col, Form, Input, notification } from 'antd'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import AppContext from '../../../../../context/AppContext'
import { useKampusDetayQuery, useKampusEkleMutation } from '../../../../../gql/GeneratedGraphqlTypes'
import Spinner from '../../../../spinner/Spinner'

const OkulSubelerDetailPage = () => {
  const { id } = useParams()
  const [form] = Form.useForm()
  const { okul } = useContext(AppContext)
  const navigate = useNavigate()
  const [kampusEkleMutation] = useKampusEkleMutation()
  const [submitting, setSubmitting] = useState(false)
  const {
    data: kampusData,
    loading: kampusLoading,
    error: kampusError,
  } = useKampusDetayQuery({
    variables: {
      id: parseInt(id ? id : '0'),
    },
    skip: !id, // ID yoksa sorguyu çalıştırma
    fetchPolicy: 'network-only',
  })

  useEffect(() => {
    if (id && kampusData?.kampusDetay) {
      form.setFieldsValue({
        okul: kampusData.kampusDetay.okul_isim || okul?.isim || '',
        isim: kampusData.kampusDetay.isim || '',
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kampusData, form, id])

  if (kampusLoading) {
    return <Spinner color="red" showSpinner={kampusLoading} />
  }
  if (submitting) {
    return <Spinner color="red" showSpinner={submitting} />
  }
  if (kampusError) {
    console.error(kampusError)
    return null
  }

  const handleSumbit = async () => {
    setSubmitting(true)
    const values = await form.validateFields()
    const input = {
      isim: values.isim,
      okul_id: kampusData?.kampusDetay?.okul_id || okul?.id || 0,
      kampus_id: parseInt(id ? id : '0'),
    }

    try {
      const response = await kampusEkleMutation({
        variables: {
          input: {
            isim: input.isim,
            okul_id: input.okul_id,
            kampus_id: input.kampus_id,
          },
        },
      })
      if (response.data?.kampusEkle.success) {
        notification.success({
          message: '',
          description: `${response.data?.kampusEkle?.message}`,
          duration: 6,
        })
        navigate(-1)
      } else {
        notification.error({
          message: '',
          description: `${response.data?.kampusEkle?.message || 'Bir hata oluştu'}.`,
          duration: 6,
        })
      }
    } catch (error) {
      notification.error({
        message: '',
        description: 'Listeyi gönderirken bir hata oluştu.',
        duration: 6,
      })
    } finally {
      setSubmitting(false) // Loading durumunu bitir
    }
  }

  return (
    <div className="okul-subeler-detail-page">
      {id ? (
        <>
          <h1> Kampüs Detayı</h1>
          <Form onFinish={handleSumbit} className="okul-yonetim-detail-form" layout="vertical" form={form}>
            <Col className="user-info-col">
              <Col span={7}>
                {' '}
                <Form.Item label="okul" name="okul" rules={[{ required: true, message: 'Lütfen okul girin!' }]}>
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={7}>
                <Form.Item label="isim" name="isim" rules={[{ required: true, message: 'Lütfen isim girin!' }]}>
                  <Input />
                </Form.Item>
              </Col>
            </Col>
            <Button className="back-btn" onClick={() => navigate(-1)}>
              Geri
            </Button>
            <Button loading={submitting} className="update-btn" htmlType="submit">
              Güncelle
            </Button>
          </Form>
        </>
      ) : (
        <>
          <h1>Yeni Kampüs Ekle</h1>
          <Form className="okul-yonetim-detail-form" onFinish={handleSumbit} layout="vertical" form={form}>
            <Col className="user-info-col">
              <Col span={7}>
                {' '}
                <Form.Item
                  label="Okul"
                  name="okul"
                  initialValue={okul?.isim || ''}
                  rules={[{ required: true, message: 'Lütfen okul girin!' }]}
                >
                  <Input disabled placeholder="Okul ismi giriniz" />
                </Form.Item>
              </Col>
              <Col span={7}>
                <Form.Item label="İsim" name="isim" rules={[{ required: true, message: 'Lütfen isim girin!' }]}>
                  <Input placeholder="İsim giriniz" />
                </Form.Item>
              </Col>
            </Col>
            <Button className="back-btn" onClick={() => navigate(-1)}>
              Geri
            </Button>
            <Button className="update-btn" htmlType="submit" loading={submitting}>
              Kaydet
            </Button>
          </Form>
        </>
      )}
    </div>
  )
}

export default OkulSubelerDetailPage
